import React, { useState, useEffect } from 'react';
import {
  Box, Tab, Tabs, Typography,
} from '@mui/material';
import { DigitalQuestion, DigitalSection, Trial } from '../../../redux/types';
import QuestionInputFormPreview from '../questionnaire/QuestionInputFormPreview';

type Props = {
  sections: Map<number, DigitalSection>;
  questions: Map<number, DigitalQuestion>;
  trial?: Trial;
};

const SectionCopyDetails: React.FC<Props> = ({
  sections,
  questions,
  trial,
}: Props) => {
  const [sectionTab, setSectionTab] = useState<number>();
  const sectionArr = [...sections.values()].sort((a, b) => a.sortIndex - b.sortIndex);
  const questionArr = [...questions.values()].sort((a, b) => a.sortIndex - b.sortIndex);
  const filteredQuestions = questionArr.filter((q) => q.digitalSectionId === sectionTab);

  useEffect(() => {
    const sectionArray = [...sections.values()];
    if (sectionTab !== undefined && !sections.get(sectionTab)) {
      if (sectionArray.length) {
        setSectionTab(sectionArray[0].id);
      } else {
        setSectionTab(undefined);
      }
    } else if (sectionTab === undefined && sectionArray.length) {
      setSectionTab(sectionArray[0].id);
    }
  }, [sectionTab, sections]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSectionTab(newValue);
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ m: 1 }}>
        {`Copy Sections to ${trial?.name}`}
      </Typography>
      {
        sectionArr.length > 0 && (
          <Tabs
            value={
              sectionTab && sections.get(sectionTab)
                ? sections.get(sectionTab)?.id : sectionArr[0].id
            }
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
          >
            {
              sectionArr.map((s) => (
                <Tab wrapped key={s.id} label={s.name} value={s.id} />
              ))
            }
          </Tabs>
        )
      }
      <Box>
        <QuestionInputFormPreview questions={filteredQuestions} />
      </Box>
    </Box>
  );
};

export default SectionCopyDetails;
